import { jsx } from "panel";
import { SelectEl } from "common/components/select";
import { CalendarEl } from "common/components/calendar";
import { ButtonBarEl } from "common/components/button-bar";
import { TooltipEl } from "common/components/tooltip";
import { DisplayType, Placement, PositioningStrategy } from "common/components/tooltip/types";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
export function template() {
  const { dateInputFocused, description, invalidDescription, saving, tmpDate } = this.state;
  const validUserPermissions = this.helpers.hasValidUserPermissions();
  return /* @__PURE__ */ jsx("div", { sel: ".create-annotation-container" }, /* @__PURE__ */ jsx("div", { sel: ".create-annotation-header" }, /* @__PURE__ */ jsx("div", { sel: ".create-annotation-label" }, "Add Annotation")), /* @__PURE__ */ jsx("div", { sel: ".create-annotation-date-input-row" }, /* @__PURE__ */ jsx("div", { sel: ".create-annotation-date-container" }, /* @__PURE__ */ jsx(
    SelectEl,
    {
      sel: ".create-annotation-date-select",
      attrs: {
        open: dateInputFocused,
        "selected-option": this.getFormattedTime(`MMM D, YYYY`)
      },
      on: {
        menuChange: this.helpers.handleDateSelectChange
      }
    },
    /* @__PURE__ */ jsx("div", { sel: ".create-annotation-date-popup-content", attrs: { slot: `body` } }, /* @__PURE__ */ jsx(
      CalendarEl,
      {
        attrs: { "selected-date": this.getFormattedTime(`YYYY-MM-DD`, tmpDate) },
        on: { selectDate: this.helpers.handleDateSelected }
      }
    )),
    /* @__PURE__ */ jsx("div", { sel: ".create-annotation-date-popup-footer", attrs: { slot: `footer` } }, /* @__PURE__ */ jsx(
      ButtonBarEl,
      {
        sel: ".mp-button-bar-primary",
        attrs: { slot: `footer` },
        on: { click: this.helpers.handleSelectDateButtonClicked }
      },
      "Select date"
    ))
  ), /* @__PURE__ */ jsx("div", { sel: ".create-annotation-at-label" }, "at")), /* @__PURE__ */ jsx("div", { sel: ".create-annotation-time-container" }, /* @__PURE__ */ jsx(
    SelectEl,
    {
      sel: ".create-annotation-time-select",
      attrs: {
        "disable-search": true,
        sections: [{ items: this.helpers.getTimeItems() }],
        "selected-option": this.getFormattedTime(`hh:mma`)
      },
      on: {
        change: this.helpers.handleTimeSelectChange
      }
    }
  ))), /* @__PURE__ */ jsx("div", { sel: ".create-annotation-description" }, /* @__PURE__ */ jsx(
    "textarea",
    {
      attrs: { placeholder: `Add a description`, maxlength: 512 },
      on: { input: this.helpers.updateDescription },
      hook: { insert: this.helpers.descriptionTextareaInserted }
    },
    description
  ), invalidDescription ? /* @__PURE__ */ jsx(
    TooltipEl,
    {
      attrs: {
        "always-show": true,
        placement: Placement.Bottom,
        type: DisplayType.Error
      }
    },
    "Please enter a description"
  ) : null), /* @__PURE__ */ jsx("div", { sel: ".create-annotation-actions-row" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: { theme: ButtonTheme.Tertiary }, on: { click: this.helpers.cancelCreation } }, "Cancel"), /* @__PURE__ */ jsx("div", { sel: ".save-annotations-button" }, /* @__PURE__ */ jsx(
    ButtonEl,
    {
      attrs: { theme: ButtonTheme.Primary, disabled: saving || !validUserPermissions },
      on: { click: this.helpers.saveAnnotation }
    },
    "Save"
  ), !validUserPermissions ? /* @__PURE__ */ jsx(
    TooltipEl,
    {
      attrs: {
        "always-show": false,
        placement: Placement.RightEnd,
        type: DisplayType.Default,
        "position-strategy": PositioningStrategy.Absolute
      }
    },
    "You don't have the requisite permissions to save an annotation. Please contact your project owner."
  ) : null)));
}
